export const money = (n) => {
  const v = Number(n || 0);
  return "£" + v.toLocaleString("en-GB", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

export const computeTotals = (lineItems = [], taxRate = 0) => {
  const subtotal = lineItems.reduce((s, li) => s + Number(li.qty || 0) * Number(li.unit_price || 0), 0);
  const tax = subtotal * (Number(taxRate || 0) / 100);
  return { subtotal: round2(subtotal), tax: round2(tax), total: round2(subtotal + tax) };
};

export const round2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

export const VAT_RATES = [0, 5, 20];
export const QTY_UNITS = ["tonnes", "kg", "cubic yards", "m³", "skips", "loads", "bags", "items"];
export const isHazardousEwc = (code) => String(code || "").includes("*");

// Totals where each line carries its own VAT rate. Falls back to a flat rate for old docs.
export const computeTotalsPerLine = (lineItems = [], fallbackRate = 0) => {
  let subtotal = 0, tax = 0;
  lineItems.forEach((li) => {
    const line = Number(li.qty || 0) * Number(li.unit_price || 0);
    const rate = li.vat_rate == null ? Number(fallbackRate || 0) : Number(li.vat_rate || 0);
    subtotal += line;
    tax += line * (rate / 100);
  });
  return { subtotal: round2(subtotal), tax: round2(tax), total: round2(subtotal + tax) };
};

export const fmtDate = (iso) => {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString("en-GB", { day: "numeric", month: "short", year: "numeric" });
  } catch { return iso; }
};

export const DOC_META = {
  quote: { label: "Quote", prefix: "QUO", color: "#E3592A" },
  invoice: { label: "Invoice", prefix: "INV", color: "#166534" },
  waste_note: { label: "Waste Note", prefix: "WTN", color: "#CA8A04" },
};
